// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Time = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.029 20.473a.8.8 0 0 0 .106-1.127l-3.833-4.632V6.937a.8.8 0 0 0-1.6 0v8.066a.8.8 0 0 0 .183.51l4.017 4.853a.798.798 0 0 0 1.127.107ZM14.502 2.4C7.554 2.4 1.9 8.053 1.9 15.003 1.9 21.949 7.554 27.6 14.5 27.6c6.948 0 12.6-5.651 12.6-12.597C27.1 8.053 21.449 2.4 14.5 2.4Zm0 26.8C6.67 29.2.3 22.83.3 15.003.3 7.17 6.67.8 14.5.8c7.83 0 14.2 6.371 14.2 14.203 0 7.828-6.37 14.197-14.2 14.197Z"
			fill="url(#Time_tsx__a)"
		/>
		<defs>
			<linearGradient id="Time_tsx__a" x1={0.301} y1={0.8} x2={28.7} y2={29.2} gradientUnits="userSpaceOnUse">
				<stop stopColor="#4A93E5" />
				<stop offset={1} stopColor="#504CCB" />
			</linearGradient>
		</defs>
	</svg>
);
export default Time;
